export default "__VITE_ASSET__xN7LK$1P__"